module.exports = __webpack_public_path__ + "static/2423-8de749fd1f9cca3cd19b107b93fec4c9.jpg";